import { Accordion, Badge, Button, ListGroup } from 'react-bootstrap';
import { FaCalendarAlt, FaCheck, FaChevronLeft, FaClock } from 'react-icons/fa';
import {
  useGetB2BSpecificAvailableSlotList,
  useSlotBookingRequest,
} from '../../apiEndpoints/b2bBuyerSellerEndpoint';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { imgUrl } from '../../../../Helpers/Constant';
import moment from 'moment';
import {
  amPmTimeShowForSlot,
  calculateDuration,
  groupSlotsByDate,
} from '../utility/b2bUtility';
import PopOver from '../../../../Components/PopOver/PopOver';
import { B2BAuthContext } from '../../../../Context/AuthContex/B2BAuthContext';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';

const AvailableSlotManage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const staff_id = searchParams.get('staff_id');
  const {
    state: { b2bUser },
  } = B2BAuthContext();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  const { data } = useGetB2BSpecificAvailableSlotList({
    user_id: Number(id),
    type: type as 'B2B' | 'Exhibitor',
    staff_id,
    own_id: b2bUser.b2b_id || exhibitorUser.user_fair_member_id,
    own_type:
      (b2bUser.b2b_id && 'B2B') ||
      (exhibitorUser.user_fair_member_id && 'Exhibitor'),
  });

  const { mutate, isPending } = useSlotBookingRequest();
  const groupedSlots = groupSlotsByDate(data?.data?.slots);
  // const appliedSlots = groupSlotsByDate(data?.data?.requestedSlots);
  return (
    <>
      <div className='d-flex align-items-center mb-4 gap-4'>
        <button onClick={() => navigate(-1)} className='back-button'>
          <FaChevronLeft className='icon' />
          <span>Back</span>
        </button>
        <div
          className='card rounded-4 p-2 border-0'
          style={{
            height: '150px',
            background:
              'linear-gradient(135deg, rgb(249 249 249), rgb(235 235 235))',
            width: '100%',
          }}
        >
          <div className='row g-0 h-100'>
            <div className='col-3 d-flex align-items-center justify-content-center'>
              <img
                src={`${imgUrl}/${data?.data?.company_logo}`}
                alt={data?.data?.company_name}
                className='rounded-circ borde'
                style={{
                  width: '230px',
                  height: '130px',
                  objectFit: 'cover',
                }}
              />
            </div>

            <div className='col-9 d-flex align-items-center'>
              <div className='row w-100 px-3'>
                <div className='col-6'>
                  <h5 className='mb-1'>Staff Name : {data?.data?.name}</h5>
                  <p className='mb-1'>
                    <strong> Designation :</strong> {data?.data?.designation}
                  </p>
                  <p className='text-'>
                    <strong> Company Name : </strong> {data?.data?.company_name}
                  </p>
                </div>
                {/* Right Column */}
                <div className='col-6'>
                  <p className='mb-1 text-dark'>
                    <strong>Profile Type:</strong> {data?.data?.type}
                  </p>

                  {data?.data?.b2b_business_type && (
                    <p className='mb-1 text-dark'>
                      <strong>Business Type:</strong>{' '}
                      {data?.data?.b2b_business_type}
                    </p>
                  )}

                  {data?.data?.company_brief && (
                    <p className='mb-0 text-dark'>
                      <strong>About Company:</strong>{' '}
                      {data?.data?.company_brief}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <h3 className='mb-3'>
        <FaCalendarAlt className='me-2' />
        Already Applied those Slots
      </h3>

      <Accordion defaultActiveKey={''}>
        {Object?.entries(groupedSlots).map(([date, dateSlots]) => (
          <Accordion.Item eventKey={date} key={date} className='mb-3 date-card'>
            <Accordion.Header>
              <div className='d-flex justify-content-between w-100 pe-3'>
                <div>
                  <FaCalendarAlt className='me-2 text-primary' />
                  <strong>{moment(date)?.format('dddd, MMM D, YYYY')}</strong>
                </div>
                <Badge bg='primary' pill>
                  {dateSlots.length} slot
                  {dateSlots.length !== 1 ? 's' : ''}
                </Badge>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <ListGroup variant='flush'>
                {dateSlots?.map((slot) => (
                  <ListGroup.Item key={slot.id} className='slot-item'>
                    <div className='d-flex justify-content-between align-items-center'>
                      <div>
                        <FaClock className='me-2 text-secondary' />
                        <strong>
                          {amPmTimeShowForSlot(slot.start_time, slot.end_time)}
                        </strong>
                        <span className='text-muted ms-2'>
                          {calculateDuration(slot.start_time, slot.end_time)}
                        </span>
                        <span className='text-muted ms-2'>
                          <Badge bg='info' pill>
                            {slot.is_available ? 'Available' : 'Booked'}
                          </Badge>
                        </span>
                      </div>

                      <PopOver
                        confirm={() =>
                          mutate({
                            slot_id: slot.id,
                            type: b2bUser.b2b_id ? 'B2B' : 'Exhibitor',
                            user_id: Number(b2bUser.b2b_id)
                              ? Number(b2bUser.b2b_id)
                              : Number(exhibitorUser.user_fair_member_id),
                          })
                        }
                        title='Are you sure to Book this ?'
                      >
                        <Button variant='primary' size='sm'>
                          <FaCheck className='me-1' />{' '}
                          {isPending ? 'Loading...' : 'Book'}
                        </Button>
                      </PopOver>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion> */}
      <h3 className='mb-3'>
        <FaCalendarAlt className='me-2' />
        Available Time Slots
      </h3>

      <Accordion defaultActiveKey={''}>
        {Object?.entries(groupedSlots).map(([date, dateSlots]) => (
          <Accordion.Item eventKey={date} key={date} className='mb-3 date-card'>
            <Accordion.Header>
              <div className='d-flex justify-content-between w-100 pe-3'>
                <div>
                  <FaCalendarAlt className='me-2 text-primary' />
                  <strong>{moment(date)?.format('dddd, MMM D, YYYY')}</strong>
                </div>
                <Badge bg='primary' pill>
                  {dateSlots.length} slot
                  {dateSlots.length !== 1 ? 's' : ''}
                </Badge>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <ListGroup variant='flush'>
                {dateSlots?.map((slot) => (
                  <ListGroup.Item key={slot.id} className='slot-item'>
                    <div className='d-flex justify-content-between align-items-center'>
                      <div>
                        <FaClock className='me-2 text-secondary' />
                        <strong>
                          {amPmTimeShowForSlot(slot.start_time, slot.end_time)}
                        </strong>
                        <span className='text-muted ms-2'>
                          {calculateDuration(slot.start_time, slot.end_time)}
                        </span>
                        <span className='text-muted ms-2'>
                          <Badge bg='info' pill>
                            {slot.is_available ? 'Available' : 'Booked'}
                          </Badge>
                        </span>
                      </div>

                      <PopOver
                        confirm={() =>
                          mutate({
                            slot_id: slot.id,
                            type: b2bUser.b2b_id ? 'B2B' : 'Exhibitor',
                            user_id: Number(b2bUser.b2b_id)
                              ? Number(b2bUser.b2b_id)
                              : Number(exhibitorUser.user_fair_member_id),
                          })
                        }
                        title='Are you sure to Book this ?'
                      >
                        <Button variant='primary' size='sm'>
                          <FaCheck className='me-1' />{' '}
                          {isPending ? 'Loading...' : 'Book'}
                        </Button>
                      </PopOver>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default AvailableSlotManage;
